<template>
  <v-dialog
    v-model="dialog"
    class="pa-0 ma-0 dialog-hidden"
    :width="qrViewer ? 1000 : ''"
  >
    <div class="back-white  mt-3  pa-0  border-white">
      <v-row class="  ma-0 pa-0 pt-3 pb-2  justify-center back-556C96">
        <span class="align-center pl-3 ">
          <h3 class="color-white ">출고 등록 수정</h3>
        </span>
      </v-row>
      <v-row class="pt-5  ma-0 ml-3 pa-0">
        <div class="pr-5">
          <span class=" justify-center align-center d-flex pl-2">
            <h5>{{ "현장명  : " + invoiceList.constructionName }}</h5>
          </span>
        </div>
        <v-spacer />
      </v-row>
      <v-row class="ma-0 pa-0 ml-3 mb-2" v-if="!qrViewer">
        <h3 class="pt-2 pr-2">입고 예정일</h3>
        <v-dialog ref="dialog1" v-model="modal1" width="388px">
          <template v-slot:activator="{ on, attrs }">
            <div class="width179-height35 align-center">
              <v-text-field
                v-model="date1"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details
                class="ma-0 pa-0"
                outlined
                dense
                :disabled="viewerRole"
              ></v-text-field>
            </div>
          </template>

          <DefaultDatePicker
            @update:date="updateReceivedDate"
            @close:date="modal1 = false"
            :resetDate="dueDate"
          />
        </v-dialog>
        <h3 class="pt-2 pr-2">출고일</h3>
        <v-dialog ref="dialog" v-model="modal" width="388px">
          <template v-slot:activator="{ on, attrs }">
            <div class="width179-height35 align-center">
              <v-text-field
                v-model="date"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details
                class="ma-0 pa-0"
                outlined
                dense
                :disabled="viewerRole"
              ></v-text-field>
            </div>
          </template>

          <DefaultDatePicker
            @update:date="updateShippedDate"
            @close:date="modal = false"
            :resetDate="registDate"
          />
        </v-dialog>
        <v-spacer />
        <h3 class="pt-2 pr-2 pl-2">송장코드</h3>

        <div class="mr-5">
          <input
            v-model="invoiceInputCode"
            :disabled="viewerRole"
            style="height:40px;border:1px solid #9E9E9E;border-radius: 4px;"
          />
        </div>
      </v-row>
      <v-row
        justify-center
        align-center
        class="ml-3 mr-3 ma-0 pa-0"
        v-if="!qrViewer"
      >
        <v-simple-table
          class="width-100"
          fixed-header
          dense
          style="max-height:300px;overflow:auto"
        >
          <thead>
            <tr class="back-8ca9dd">
              <th
                class="text-center back-8ca9dd color-white border-right-white "
                rowspan="2"
              >
                발주차수
              </th>
              <th
                class="text-center back-8ca9dd color-white border-right-white"
                rowspan="2"
              >
                발주 부위
              </th>
              <th
                class="text-center back-8ca9dd color-white border-right-white"
                rowspan="1"
                :colspan="materialLength"
              >
                규격(단위:TON)
              </th>
              <th
                class="text-center back-8ca9dd color-white  border-right-white"
                rowspan="2"
              >
                합계수량
              </th>
              <th class="text-center back-8ca9dd color-white" rowspan="2">
                입고예정일자
              </th>
              <th class="text-center back-8ca9dd color-white" rowspan="2">
                발주일자
              </th>
            </tr>
            <tr>
              <th
                class="text-center back-8ca9dd color-white border-top-white border-right-white"
                v-for="(material, index) in materialList"
                :key="index"
              >
                {{ material.rebar_name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(invoice, k) in invoiceList.rows" :key="invoice.orderId">
              <td
                class="border-right-aaaaaa  border-bottom-aaaaaa text-center "
              >
                {{ invoice.orderName }}
              </td>
              <td
                class="border-right-aaaaaa border-bottom-aaaaaa text-center part-btn"
              >
                {{ invoice.partName }}
              </td>
              <td
                class="border-right-aaaaaa border-bottom-aaaaaa  text-center"
                v-for="(index, i) in invoice.rebarList"
                :key="(k + 1) * (i + 10)"
              >
                <input
                  v-model.number="invoice.rebarList[i]"
                  class="text-center pa-0 border-aaaaaa width-50 "
                  type="number"
                  @focus="focusClear(invoice.rebarList[i], k, i)"
                  :disabled="viewerRole"
                />
              </td>
              <td class="border-right-aaaaaa border-bottom-aaaaaa  text-center">
                {{ sum(invoice.rebarList).toFixed(3) }}
              </td>
              <td class="border-right-aaaaaa border-bottom-aaaaaa  text-center">
                {{ dateCheck(invoiceList.dueDate) }}
              </td>

              <td class="border-right-aaaaaa border-bottom-aaaaaa  text-center">
                {{ dateCheck(invoice.registDate) }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-row>
      <v-row class=" pt-5 pb-5 mr-3 justify-center ma-0 pa-0" v-if="!qrViewer">
        <v-btn
          color="#ffffff"
          class="btn-ff5b5a ml-3"
          width="150"
          height="40"
          @click="deleteInvoice"
          v-if="
            (!completion && userType != '발주담당자') ||
              userType == '현장관리자' ||
              userType == '시스템관리자'
          "
          :disabled="viewerRole"
          >삭제</v-btn
        >
        <v-btn
          color="#739EEC"
          class="color-white ml-3"
          width="150"
          height="40"
          @click="confirmInvoice"
          v-if="
            (!completion && userType != '발주담당자') ||
              userType == '현장관리자' ||
              userType == '시스템관리자'
          "
          :disabled="viewerRole"
          >확인</v-btn
        >
        <v-btn
          color="#eeeeee"
          class="ml-3"
          width="150"
          height="40"
          @click="dialog = false"
          >닫기</v-btn
        >
        <h4 v-if="completion && userType == '입고담당자'">
          이미 입고완료 처리가 된 차수입니다.
        </h4>
      </v-row>
      <v-row class="ma-0 pa-0" v-if="qrViewer">
        <div class="ml-5 mb-3">
          출고데이터 수정이 완료 되었습니다.<br />
          QR 코드는 아래와 같습니다.
        </div>
      </v-row>
      <v-row class="ma-0 pb-5 pa-0" v-if="qrViewer">
        <div class="ml-5 mr-3">
          <qr-code :text="qrCode" size="150" color="#000000"></qr-code>
        </div>
        <div class="align-center d-flex width-350">
          QR코드 링크 URL<br />
          <a :href="qrCode">{{ qrCode }}</a>
        </div>
        <v-spacer />
        <div class="align-end d-flex">
          <v-btn
            color="#3F557D"
            class="color-white qr-btn"
            width="150"
            height="40"
            v-clipboard:copy="qrCode"
            :disabled="viewerRole"
          >
            QR링크 복사
          </v-btn>
          <v-btn
            color="#718FC7"
            class="color-white qr-btn"
            width="150"
            height="40"
            @click="dialog = !dialog"
          >
            확인
          </v-btn>
        </div>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import InvoiceApi from "@/api/InvoiceService";
import Commonality from "@/mixin/Commonality";
import VueQRCodeComponent from "vue-qrcode-component";
import DefaultDatePicker from "@/components/DefaultDatePicker.vue";

export default {
  mixins: [Commonality],
  components: {
    "qr-code": VueQRCodeComponent,
    DefaultDatePicker,
  },

  created() {
    this.$bus.$on("invoiceDetail", (data) => {
      this.$bus.$emit("loadingStart");
      this.qrViewer = false;
      this.invoiceId = data;
      this.reset();
      this.dialog = true;
      this.$bus.$emit("loadingEnd");
    });
  },
  beforeDestroy() {
    this.$bus.$off("invoiceDetail");
  },
  data: () => ({
    invoiceList: [],
    dialog: false,
    invoiceId: "",
    qrCode: `${window.location.protocol}//${window.location.host}/qrCode?qrText=`,
    qrViewer: false,
    completion: false,
    modal: false,
    date:
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate(),
    date1:
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate(),
    modal1: false,
    invoiceInputCode: "",
    dueDate: null,
    registDate: null,
  }),

  computed: {
    materialLength() {
      return this.materialList.length;
    },

    userInfo() {
      return this.$store.getters.getUserList;
    },

    userType() {
      return this.userInfo.roleType;
    },
    viewerRole() {
      return this.$store.getters.getUserList.roleType === "뷰어";
    },
  },
  methods: {
    updateReceivedDate(date) {
      this.date1 = date;
      this.modal1 = false;
    },
    updateShippedDate(date) {
      this.date = date;
      this.modal = false;
    },
    async deleteInvoice() {
      let data = { orderId: 0, invoiceId: this.invoiceList.invoiceId };
      const isFailList = [];

      for (let i = 0; i < this.invoiceList.rows.length; i++) {
        data.orderId = this.invoiceList.rows[i].orderId;

        const res = await InvoiceApi.invoiceDelete(data);
        if (res.data.success === "fail") {
          const orderName = this.invoiceList.rows[i].orderName;
          isFailList.push(orderName);
        }
      }

      this.dialog = false;
      const isSuccess = isFailList.length === 0;

      const failText = `${isFailList.join(
        ", "
      )} 발주차수는 마감 처리된 데이터입니다.`;
      const text = isSuccess ? "삭제가 완료되었습니다." : failText;

      this.$bus.$emit("dialog", text, isSuccess);
      if (isSuccess) {
        this.$bus.$emit("invoiceNavigationDuplicated");
      }
    },

    focusClear(val, i, j) {
      if (val != 0) return;
      let list = [];
      for (let k = 0; k < this.invoiceList.rows[i].rebarList.length; k++) {
        if (k != j)
          list.push(this.mathRound(this.invoiceList.rows[i].rebarList[k]));
        else list.push("");
      }
      this.invoiceList.rows[i].rebarList = list;
    },

    async reset() {
      let datas = {
        invoiceId: this.invoiceId,
      };
      let invoiceTempData = await InvoiceApi.invoiceDetail(datas);
      this.invoiceList = invoiceTempData.data.invoiceDetail;
      this.date1 = invoiceTempData.data.invoiceDetail.dueDate;
      this.date = invoiceTempData.data.invoiceDetail.registDate;
      this.dueDate = invoiceTempData.data.invoiceDetail.dueDate;
      this.registDate = invoiceTempData.data.invoiceDetail.registDate;
      this.invoiceInputCode =
        invoiceTempData.data.invoiceDetail.invoiceInputCode;
      this.invoiceList.completion == "Y"
        ? (this.completion = true)
        : (this.completion = false);
    },

    async confirmInvoice() {
      let data = {
        constructionId: this.invoiceList.constructionId,
        invoiceId: this.invoiceList.invoiceId,
        orderId: [],
        rebarListData: [],
        selectDate: this.date,
        dueDate: this.date1,
        invoiceInputCode: this.invoiceInputCode,
      };
      let index = 0;
      for (let i = 0; i < this.invoiceList.rows.length; i++) {
        data.orderId[index] = this.invoiceList.rows[i].orderId;
        for (let j = 0; j < this.invoiceList.rows[i].rebarList.length; j++) {
          this.invoiceList.rows[i].rebarList[j] =
            this.invoiceList.rows[i].rebarList[j] == ""
              ? 0
              : Number(this.invoiceList.rows[i].rebarList[j]);
        }
        data.rebarListData[index] = [];
        for (let j = 0; j < this.materialLength; j++) {
          data.rebarListData[index].push({
            rebarName: this.materialList[j].rebar_name,
            rebarValue:
              this.invoiceList.rows[i].rebarList[j] == ""
                ? 0
                : Number(this.invoiceList.rows[i].rebarList[j]),
          });
        }
        index++;
      }
      let returnData = await InvoiceApi.invoiceUpdate(data);
      if (returnData.data.success == "ok") {
        this.qrCode = `${window.location.protocol}//${window.location.host}/qrCode?qrText=${returnData.data.qrString}`;
        this.qrViewer = true;
        this.$bus.$emit("invoiceNavigationDuplicated");
      } else this.$bus.$emit("dialog", "확인후 다시 시도해주세요.");
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-btn[disabled],
.v-btn:disabled {
  border: 1px solid transparent !important;
}
input[disabled],
input:disabled {
  border: 1px solid rgba(228, 228, 228, 0.795) !important;
}
.v-data-table__wrapper {
  max-height: 480px;
}

.v-data-table--fixed-header > .v-data-table__wrapper {
  max-height: 480px;
}

.width-350 {
  width: 350px !important;
}

.qr-btn {
  margin-top: 95px;
  margin-right: 15px;
}

.span-setting1 {
  text-align: center;
  background: #dde0e7;
  border-radius: 25px;
  width: 130px;
  height: 38px;
  vertical-align: middle;
}

.span-setting2 {
  text-align: center;
  background: #dde0e7;
  border-radius: 25px;
  width: 216px;
  height: 38px;
  vertical-align: middle;
}

.v-dialog {
  margin: 0px !important;
  overflow-y: hidden !important;
}

.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 0px !important;
}

.part-btn {
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.dialog-hidden {
  overflow-y: hidden !important;
}

.width-50 {
  width: 50px;
}
</style>
